// extracted by mini-css-extract-plugin
export var cashout = "BetEntryClamp-module--cashout--a1039";
export var clamp = "BetEntryClamp-module--clamp--e963f";